import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

import Box from '@material-ui/core/Box'
import Paper from '@material-ui/core/Paper'
import Divider from '@material-ui/core/Divider'
import Skeleton from '@material-ui/lab/Skeleton'
import Typography from '@material-ui/core/Typography'

import {
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
} from '@material-ui/core'

import helpers from 'helpers'

import styles from './styles'

import moment from 'moment'

const useStyles = makeStyles(styles)

const ContractHistory = ({ contract }) => {
  const classes = useStyles()

  return (
    <Paper>
      <Box p={2}>
        <Typography variant="h4">Histórico da assinatura</Typography>
      </Box>
      <Divider />
      <div className={classes.tableWrapper}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Data e Hora</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Observação</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {contract && contract.historyContractStatuses.length > 0 ? (
              contract.historyContractStatuses.map((history, index) => {
                if (history) {
                  return (
                    <ItemRow
                      key={index}
                      date={history.createdAt}
                      status={history.status}
                      observation={history.observation}
                    />
                  )
                }

                return <SkeletonRow key={index} />
              })
            ) : (
              <TableRow>
                <TableCell colSpan={5}>
                  <Box p={2} display="block">
                    <Typography variant="overline">
                      Não há nenhuma mudança de status desta assinatura
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </Paper>
  )
}

const ItemRow = ({ date, status, observation }) => (
  <TableRow>
    <TableCell>
      {moment(date)
        .utc(false)
        .format('DD/MM/YYYY HH:mm:ss')}
    </TableCell>
    <TableCell>{helpers.historyContractStatuses.status(status)}</TableCell>
    <TableCell>
      {helpers.historyContractStatuses.message(observation)}
    </TableCell>
  </TableRow>
)

const SkeletonRow = () => (
  <TableRow>
    <TableCell>
      <Skeleton variant="rect" width="100%" />
    </TableCell>
    <TableCell>
      <Skeleton variant="rect" width="100%" />
    </TableCell>
    <TableCell>
      <Skeleton variant="rect" width="100%" />
    </TableCell>
  </TableRow>
)

export default ContractHistory
